import React, { useEffect, useState } from 'react';
import { Button, Col, Collapse, Form, Input, List, Radio, RadioChangeEvent, Row, Select } from 'antd';
import useGetRequestUpgrade from '../../hooks/utils/useGetRequestUpgrade';
import { UsageLimitState } from './UsageLimitState';
import './usage-limits.css'
import useToastContext from '../../hooks/useToastContext';
import { validateStatus } from '../../utils/utils';
import usePatchRequest from '../../hooks/utils/usePatchRequest';

export type UsageLimits = {
  id: string;
  name: string;
  // eslint-disable-next-line camelcase
  created_timestamp: string;
  // eslint-disable-next-line camelcase
  allow_ecommerce: UsageLimitState;
  // eslint-disable-next-line camelcase
  allow_purchase_chip: UsageLimitState;
  // eslint-disable-next-line camelcase
  allow_purchase_contactless: UsageLimitState;
  // eslint-disable-next-line camelcase
  allow_atm_operation: UsageLimitState;
  // eslint-disable-next-line camelcase
  allow_atm_withdrawal: UsageLimitState;
  // eslint-disable-next-line camelcase
  allow_oct: UsageLimitState;
  // eslint-disable-next-line camelcase
  allow_purchase_magnetic_stripe: UsageLimitState;
  // eslint-disable-next-line camelcase
  banned_mcc_list?: string[];
  // eslint-disable-next-line camelcase
  banned_tcc_list?: string[];
  // eslint-disable-next-line camelcase
  countries_black_list?: string[];
  // eslint-disable-next-line camelcase
  countries_white_list?: string[];
}

const LimitDesign = ({ limit, action }: { limit?: UsageLimits, action: string }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldValue('id', limit?.id);
    form.setFieldValue('name', limit?.name);
    form.setFieldValue('created_timestamp', limit?.created_timestamp);
    form.setFieldValue('allow_ecommerce', limit?.allow_ecommerce);
    form.setFieldValue('allow_purchase_chip', limit?.allow_purchase_chip);
    form.setFieldValue('allow_purchase_contactless', limit?.allow_purchase_contactless);
    form.setFieldValue('allow_atm_operation', limit?.allow_atm_operation);
    form.setFieldValue('allow_atm_withdrawal', limit?.allow_atm_withdrawal);
    form.setFieldValue('allow_oct', limit?.allow_oct);
    form.setFieldValue('allow_purchase_magnetic_stripe', limit?.allow_purchase_magnetic_stripe);
    form.setFieldValue('banned_mcc_list', action === 'view' ? limit?.banned_mcc_list?.join(", ") : limit?.banned_mcc_list);
    form.setFieldValue('banned_tcc_list', action === 'view' ? limit?.banned_tcc_list?.join(", ") : limit?.banned_tcc_list);
    form.setFieldValue('countries_black_list', action === 'view' ? limit?.countries_black_list?.join(", ") : limit?.countries_black_list);
    form.setFieldValue('countries_white_list', action === 'view' ? limit?.countries_white_list?.join(", ") : limit?.countries_white_list);
}, [limit]);

  const onSubmit = () => {

  }

  return (
    <Form<UsageLimits>
      layout="vertical"
      onFinish={onSubmit}
      form={form}
    >
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item<UsageLimits>
            label="Compras en comercio electrónico"
            name="allow_ecommerce"
            initialValue={ limit?.allow_ecommerce }
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Seleccionar tipo"
              showSearch
              options={Object.values(UsageLimitState).map((type) => ({ label: type, value: type }))}
              disabled={ action === 'view' }
            />
          </Form.Item>
          <Form.Item<UsageLimits>
            label="Compras con chip"
            name="allow_purchase_chip"
            initialValue={ limit?.allow_purchase_chip }
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Seleccionar tipo"
              showSearch
              options={Object.values(UsageLimitState).map((type) => ({ label: type, value: type }))} 
              disabled={ action === 'view' }
            />
          </Form.Item>
          <Form.Item<UsageLimits>
            label="Compras con contactless"
            name="allow_purchase_contactless"
            initialValue={ limit?.allow_purchase_contactless }
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Seleccionar tipo"
              showSearch
              options={Object.values(UsageLimitState).map((type) => ({ label: type, value: type }))} 
              disabled={ action === 'view' }
            />
          </Form.Item>
          <Form.Item<UsageLimits>
            label="Operaciones en cajeros"
            name="allow_atm_operation"
            initialValue={ limit?.allow_atm_operation }
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Seleccionar tipo"
              showSearch
              options={Object.values(UsageLimitState).map((type) => ({ label: type, value: type }))} 
              disabled={ action === 'view' }
            />
          </Form.Item>
          <Form.Item<UsageLimits>
            label="Extraccion por cajeros"
            name="allow_atm_withdrawal"
            initialValue={ limit?.allow_atm_withdrawal }
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Seleccionar tipo"
              showSearch
              options={Object.values(UsageLimitState).map((type) => ({ label: type, value: type }))} 
              disabled={ action === 'view' }
            />
          </Form.Item>
        </Col>
        <Col  span={12}>
          <Form.Item<UsageLimits>
            label="Códigos de categoría prohibidos"
            name="banned_mcc_list"
            rules={[{ required: true }]}
          >
            {
              action === 'view' ? (
                <Input
                  disabled
                />
              ) : (
                <Select
                  placeholder="Seleccionar tipo"
                  showSearch
                  options={Object.values(limit?.banned_mcc_list || []).map((type) => ({ label: type, value: type }))}
                  disabled={ action === 'view' }
                />
              )
            }
          </Form.Item>
          <Form.Item<UsageLimits>
            label="Códigos de transacciones prohibidas"
            name="banned_tcc_list"
            rules={[{ required: true }]}
          >
            {
              action === 'view' ? (
                <Input
                  disabled
                />
              ) : (
                <Select
                  placeholder="Seleccionar tipo"
                  showSearch
                  options={Object.values(limit?.banned_tcc_list || []).map((type) => ({ label: type, value: type }))}
                  disabled={ action === 'view' }
                />
              )
            }

          </Form.Item>
          <Form.Item<UsageLimits>
            label="Paises prohibidos"
            name="countries_black_list"
            rules={[{ required: true }]}
          >
            {
              action === 'view' ? (
                <Input
                  disabled
                />
              ) : (
                <Select
                  placeholder="Seleccionar tipo"
                  showSearch
                  options={Object.values(limit?.countries_black_list || []).map((type) => ({ label: type, value: type }))}
                  disabled={ action === 'view' }
                />
              )
            }
          </Form.Item>
          <Form.Item<UsageLimits>
            label="Paises habilitados"
            name="countries_white_list"
            rules={[{ required: true }]}
          >
            {
              action === 'view' ? (
                <Input
                  disabled
                />
              ) : (
                <Select
                  placeholder="Seleccionar tipo"
                  showSearch
                  options={Object.values(limit?.countries_white_list || []).map((type) => ({ label: type, value: type }))}
                  disabled={ action === 'view' }
                />
              )
            }
          </Form.Item>
          <Form.Item<UsageLimits>
            label="Operaciones OCT"
            name="allow_oct"
            initialValue={ limit?.allow_oct }
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Seleccionar tipo"
              showSearch
              options={Object.values(UsageLimitState).map((type) => ({ label: type, value: type }))} 
              disabled={ action === 'view' }
            />
          </Form.Item>
          <Form.Item<UsageLimits>
            label="Compras con banda magnetica"
            name="allow_purchase_magnetic_stripe"
            initialValue={ limit?.allow_purchase_magnetic_stripe }
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Seleccionar tipo"
              showSearch
              options={Object.values(UsageLimitState).map((type) => ({ label: type, value: type }))} 
              disabled={ action === 'view' }
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

const UsageLimit = ({
  cardAffinityGroupId,
  action,
  usageLimit,
  setUsageLimit
}: {
  cardAffinityGroupId?: string | undefined;
  action?: string | 'view';
  usageLimit?: UsageLimits | undefined;
  setUsageLimit?: (value: UsageLimits) => void;
}) => {
  const { patchError, patchLoading, executePatch } = usePatchRequest({ path:  `v1/card_affinity_groups/${cardAffinityGroupId}/usage_limits` });
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const { getData: usageLimits, getLoading: loading } = useGetRequestUpgrade({ path : `v1/usage_limits?page_size=${paginationModel.pageSize}&page_number=${paginationModel.page}` });
  const [dataList, setDatalist] = useState<UsageLimits[]>([]);
  const [usageLimitSelected, setUsageLimitSelected] = useState<UsageLimits>(usageLimit);
  const toast = useToastContext();

  useEffect(() => {
    setDatalist(usageLimits?.data);

    if(usageLimit === undefined || usageLimit === null)
      setUsageLimitSelected(usageLimits?.data[0]?.name);

  }, [usageLimits]);

  useEffect(() => {
    if(usageLimit !== undefined && usageLimit !== null)
      setUsageLimitSelected(usageLimit);
  }, [usageLimit]);

  const handlePaginationChange = (page: number, pageSize: number) => {
    setPaginationModel({ page: page - 1, pageSize });
  };

  useEffect(() => {
    setUsageLimit && setUsageLimit(usageLimitSelected)
  }, [usageLimitSelected]);

  const saveUsageLimit = async () => {
    if(cardAffinityGroupId !== undefined && cardAffinityGroupId !== null ) {
      try {
        const response = await executePatch({ data: { usage_limits_id: Number(usageLimit?.id) } });

        if (validateStatus(response?.status)) {
          toast.success('Exito', 'Limitador de uso actualizado correctamente!.');
        } else {
          throw new Error();
        }

      } catch (e: unknown) {
        toast.error('Error', `Ocurrió un error: ${patchError}, porfavor, intenta nuevamente.`);
      }
    }

  }

  function getItemList(ul: UsageLimits) {
    return [{
      key: ul?.name,
      label: ul?.name,
      children: <LimitDesign limit={ul} action={'view'} />
    }];
  }

  const setUsageLimitValue = (e: RadioChangeEvent) => {
    setUsageLimitSelected(usageLimits?.data?.find(item => item.id === e?.target?.value ));
  }

  return (
    <>
      <Row gutter={24}>
        <Col span={18} offset={2}>
          <Radio.Group
            style={{ width: '100%' }}
            onChange={ setUsageLimitValue }
            value={usageLimitSelected?.id}
          >
            <List
              className="pagination-bottom-fixed"
              scroll={{ x: true }}
              pagination={{
                total: usageLimits?.pagination?.total_rows,
                showTotal: (total) => usageLimits?.pagination?.total_rows !== undefined ? `Total: ${total}` : ``,
                position: 'bottom',
                align: 'start',
                defaultPageSize: 10,
                defaultCurrent: 1,
                onChange: handlePaginationChange,
                pageSizeOptions: ['10', '25', '50'],
                showSizeChanger: true,
              }}
              dataSource={dataList}
              loading={loading}
              renderItem={ (item) => (
                <List.Item style={{ alignItems: 'flex-start'}}>
                  <Radio value={item?.id}></Radio>
                  <Collapse
                    style={{ width: '100%' }}
                    items={ getItemList(item) }
                    expandIconPosition={ 'end' }
                    className={"list-item-ant"}
                    ghost={true}
                    destroyInactivePanel={true}
                  />
                </List.Item>
              )}
            />
          </Radio.Group>
        </Col>
        <Col span={24} style={{ textAlign: 'right' }}>
          {
            action !== 'view' ? (
              <Button
                type="primary"
                htmlType="submit"
                onClick={saveUsageLimit}
                loading={patchLoading}
              >
                { cardAffinityGroupId !== undefined && cardAffinityGroupId !== null ? 'Guardar' : `Crear` }
              </Button>
            ): ''
          }
        </Col>
      </Row>
    </>
  )
};

export default UsageLimit;